/* tslint:disable */
/* eslint-disable */
/* @relayHash 9ea3c78cc7d83ca89361f9cf43cf60e2 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DeleteClassroomMembershipInput = {
    id: string;
    clientMutationId?: string | null;
};
export type DeleteClassroomMembershipMutationVariables = {
    input: DeleteClassroomMembershipInput;
};
export type DeleteClassroomMembershipMutationResponse = {
    readonly deleteClassroomMembership: {
        readonly id: string;
        readonly classroom: {
            readonly id: string;
            readonly numActiveMemberships: number;
        } | null;
        readonly viewer: {
            readonly " $fragmentRefs": FragmentRefs<"DashboardLayout_viewer">;
        } | null;
    } | null;
};
export type DeleteClassroomMembershipMutation = {
    readonly response: DeleteClassroomMembershipMutationResponse;
    readonly variables: DeleteClassroomMembershipMutationVariables;
};



/*
mutation DeleteClassroomMembershipMutation(
  $input: DeleteClassroomMembershipInput!
) {
  deleteClassroomMembership(input: $input) {
    id
    classroom {
      id
      numActiveMemberships
    }
    viewer {
      ...DashboardLayout_viewer
    }
  }
}

fragment DashboardLayout_viewer on Viewer {
  user {
    id
    isAdmin
    accountType
    isUpgradedTeacher
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteClassroomMembershipInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classroom",
  "storageKey": null,
  "args": null,
  "concreteType": "Classroom",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "numActiveMemberships",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteClassroomMembershipMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteClassroomMembership",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteClassroomMembershipPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Viewer",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "DashboardLayout_viewer",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteClassroomMembershipMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteClassroomMembership",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteClassroomMembershipPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Viewer",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isAdmin",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accountType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isUpgradedTeacher",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classroomMemberships",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ClassroomMembership",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "level",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "classroom",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Classroom",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "identifier",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteClassroomMembershipMutation",
    "id": null,
    "text": "mutation DeleteClassroomMembershipMutation(\n  $input: DeleteClassroomMembershipInput!\n) {\n  deleteClassroomMembership(input: $input) {\n    id\n    classroom {\n      id\n      numActiveMemberships\n    }\n    viewer {\n      ...DashboardLayout_viewer\n    }\n  }\n}\n\nfragment DashboardLayout_viewer on Viewer {\n  user {\n    id\n    isAdmin\n    accountType\n    isUpgradedTeacher\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'b950da12e7df2275ac23bbc322295e8e';
export default node;
